import { useForm } from "react-hook-form";
import useAccountEnhanced from "src/hooks/use-account-enhanced";
import toast from "react-hot-toast";
import { useCreateOrderNote } from "src/api/mvte-query-options";

type AddNoteInputs = {
    noteType: string;
    noteText: string;
};

export function OrderAddNoteForm({
    customerCode,
    orderNumber,
    onSuccess,
}: {
    customerCode: string;
    orderNumber: string;
    onSuccess: () => void;
}) {
    const createOrderNoteMutation = useCreateOrderNote({
        orderNumber: orderNumber,
    });
    const accountEnhanced = useAccountEnhanced();
    const form = useForm<AddNoteInputs>();

    async function onSubmit({ noteType, noteText }: AddNoteInputs) {
        await createOrderNoteMutation.mutateAsync({
            EmployeeCode: accountEnhanced.me.employeeCode.toUpperCase(),
            NoteText: noteText,
            NoteType: noteType,
            Payload: {
                CustomerCode: customerCode ?? "",
                OrderNumber: orderNumber ?? "",
            },
            UserPrincipalName: accountEnhanced.account.name ?? "",
        });

        form.reset();
        toast.success("Note added successfully");

        onSuccess();
    }
    return (
        <>
            <form
                id="addNoteForm"
                className="space-y-2"
                onSubmit={form.handleSubmit(onSubmit)}
            >
                <select
                    className="select select-bordered select-sm w-full"
                    {...form.register("noteType", { required: true })}
                >
                    <option value="">Select Note Type</option>
                    <option value="Billing">Billing</option>
                    <option value="Collections">Collections</option>
                    <option value="Rating">Rating</option>
                    <option value="Customer Account">Customer Account</option>
                    <option value="Dispatch">Dispatch</option>
                    <option value="Payroll">Payroll</option>
                    <option value="Risk">Risk</option>
                    <option value="Service Failures">Service Failures</option>
                </select>
                <textarea
                    className="textarea textarea-bordered w-full"
                    rows={3}
                    placeholder="Note"
                    {...form.register("noteText", { required: true })}
                ></textarea>
            </form>
            <div className="card-actions justify-end">
                <button
                    form="addNoteForm"
                    className="btn btn-sm btn-neutral"
                    type="submit"
                    disabled={!orderNumber}
                >
                    {form.formState.isSubmitting ? (
                        <>
                            <span className="loading loading-spinner"></span>
                            loading
                        </>
                    ) : (
                        "Submit"
                    )}
                </button>
            </div>
        </>
    );
}
